import apiClient from './api';
import { LoginForm, LoginResponse, User } from '../types';
import type { UserProviderOrderSettlementSummary, UserProviderSettlementSummary } from './userService';

// 认证服务
export const authService = {
  // 用户登录
  login: async (loginData: LoginForm): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login', loginData);
    return response.data;
  },

  // 获取用户信息
  getUserInfo: async (): Promise<User> => {
    const response = await apiClient.get<User>('/auth/profile');
    return response.data;
  },

  // 获取当前代理商结算流水
  getMyProviderSettlementFlows: async (): Promise<UserProviderSettlementSummary> => {
    const response = await apiClient.get<UserProviderSettlementSummary>('/auth/provider-settlement-flows');
    return response.data;
  },

  // 获取当前代理商收入流水
  getMyProviderOrderSettlementFlows: async (): Promise<UserProviderOrderSettlementSummary> => {
    const response = await apiClient.get<UserProviderOrderSettlementSummary>('/auth/provider-order-settlement-flows');
    return response.data;
  },

  // 用户登出
  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout');
  },
};
